import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  QuoteDTO,
  RefundDTO,
  RefundFeeDTO,
  RefundFeePayloadSchema,
  RefundFlowType,
} from 'views/types';

const baseUrl = '/api/v1/';
// const baseUrl = 'https://payment.cryptopay-dev.space-app.io/api/v1/';
const tags = ['Refund'];

export const refundApi = createApi({
  reducerPath: 'refundApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
  }),
  tagTypes: tags,
  endpoints: (builder) => ({
    postCryptoRefundQuoteRequest: builder.mutation<
      QuoteDTO,
      { authToken: string; refundFlow: RefundFlowType }
    >({
      invalidatesTags: tags,
      query: ({ authToken, refundFlow = 'Full' }) => ({
        url: 'payment-intents/crypto-refunds/quote-request',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: {
          refundFlow,
        },
      }),
    }),
    postRefundFee: builder.mutation<
      RefundFeeDTO,
      { refundFeeData: RefundFeePayloadSchema } & { authToken: string }
    >({
      invalidatesTags: tags,
      query: ({ refundFeeData, authToken }) => ({
        url: 'payment-intents/crypto-refunds/fee',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: refundFeeData,
      }),
    }),
    postRefund: builder.mutation<RefundDTO, { authToken: string; refundFlow: RefundFlowType }>({
      invalidatesTags: tags,
      query: ({ authToken, refundFlow = 'Full' }) => ({
        url: 'payment-intents/crypto-refunds',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: {
          refundFlow,
        },
      }),
    }),
  }),
});

export const {
  usePostCryptoRefundQuoteRequestMutation,
  usePostRefundFeeMutation,
  usePostRefundMutation,
} = refundApi;
